/* tslint:disable */
/* eslint-disable */
/**
 * Strømbestilling API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status for verving
 * @export
 */
export const Vervestatus = {
    Opprettet: 'OPPRETTET',
    Manuell: 'MANUELL',
    Utbetalt: 'UTBETALT',
    Avvist: 'AVVIST',
    Forlatt: 'FORLATT'
} as const;
export type Vervestatus = typeof Vervestatus[keyof typeof Vervestatus];


export function instanceOfVervestatus(value: any): boolean {
    for (const key in Vervestatus) {
        if (Object.prototype.hasOwnProperty.call(Vervestatus, key)) {
            if (Vervestatus[key as keyof typeof Vervestatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VervestatusFromJSON(json: any): Vervestatus {
    return VervestatusFromJSONTyped(json, false);
}

export function VervestatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): Vervestatus {
    return json as Vervestatus;
}

export function VervestatusToJSON(value?: Vervestatus | null): any {
    return value as any;
}

export function VervestatusToJSONTyped(value: any, ignoreDiscriminator: boolean): Vervestatus {
    return value as Vervestatus;
}

